import React from "react";

const Input = ({
  select,
  signup,
  setState,
  state,
  label,
  placeholder,
  name,
  type,
  expression,
  errorMessage,
  username,
  password,
  options,
  classInput,
  classLabel,
  classBlock
}) => {
  const onChange = (e) => {
    setState({ ...state, value: e.target.value });
  };

  const validation = () => {
    if (username) {
      if (!username.value === undefined) {
        if (
          state.value.toLowerCase().indexOf(username.value.toLowerCase()) !== -1
        ) {
          setState({ ...state, error: "false" });
        } else {
          setState({ ...state, error: "true" });
        }
      }
    }
    if (password) {
      if (state.value === password.value) {
        setState({ ...state, error: "true" });
      } else {
        setState({ ...state, error: "false" });
      }
    }
    if (expression) {
      if (expression.test(state.value)) {
        setState({ ...state, error: "true" });
      } else {
        setState({ ...state, error: "false" });
      }
    }
  };

  return (
    <div className={`boxInput ${classBlock ?? ''}`}>
      <div className="divLabel">
        <label className={classLabel ?? ''}>{label}</label>
      </div>
      <div className={signup ? `divInputSignup` : `divInput`}>
        {select ? (
          <select
            placeholder={placeholder}
            id={name}
            name={name}
            onChange={onChange}
            type={type}
            onKeyUp={validation}
            onBlur={validation}
            className={` ${state.error === "false" ? "error-input" : "success-input"
              } ${signup ? "input-form-signup" : "input-form"}  ${classInput ?? ''}`}
          >
            {options.map((option) => (
              <option key={option.name} value={option.name}>{option.name}</option>
            ))}
          </select>
        ) : (
          <input
            placeholder={placeholder}
            id={name}
            name={name}
            onChange={onChange}
            className={` ${state.error === "false" ? "error-input" : "success-input"
              } ${signup ? "input-form-signup" : "input-form"} ${classInput ?? ''}`  }
            type={type}
            onKeyUp={validation}
            onBlur={validation}
          />
        )}

        {state.error === "false" ? (
          <div
            className={`${signup ? "message-error" : "alert alert-danger"}`}
            role="alert"
          >
            &#8226; {errorMessage}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Input;
